import React, { useContext, useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { GlobalContext } from '../../context/userContext';
import { dashboardRangeError, dateInputValue, isHistoricalRange } from '../../utils/dashboard-range';

export default function DashboardDateRange() {
  const { startDate, endDate, setStartDate, setEndDate } = useContext(GlobalContext);
  const [start, setStart] = useState(dateInputValue(startDate));
  const [end, setEnd] = useState(dateInputValue(endDate));

  useEffect(() => {
    if (startDate) {
      setStart(dateInputValue(startDate));
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
      setEnd(dateInputValue(endDate));
    }
  }, [endDate]);

  const error = dashboardRangeError(start, end);
  const historical = isHistoricalRange(endDate);

  const applyRangeIfValid = (newStart: string, newEnd: string) => {
    if (!newStart || !newEnd) return;
    const err = dashboardRangeError(newStart, newEnd);
    if (!err) {
      const s = new Date(`${newStart}T00:00:00`);
      const e = new Date(`${newEnd}T23:59:59.999`);
      localStorage.setItem('StartDate', s.toISOString());
      localStorage.setItem('EndDate', e.toISOString());
      setStartDate(s);
      setEndDate(e);
    }
  };

  const handleStartChange = (val: string) => {
    setStart(val);
    applyRangeIfValid(val, end);
  };

  const handleEndChange = (val: string) => {
    setEnd(val);
    applyRangeIfValid(start, val);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        p: 1,
        borderRadius: 1,
        border: '1px solid',
        borderColor: historical ? '#c99700' : 'divider',
        bgcolor: historical ? '#fff3bf' : 'background.paper',
        color: historical ? '#533f00' : 'text.primary',
      }}
    >
      <Typography
        component="span"
        sx={{
          position: 'absolute',
          top: '-0.65em',
          left: '0.75rem',
          bgcolor: historical ? '#fff3bf' : 'background.paper',
          px: '4px',
          fontSize: '12px',
          color: historical ? '#533f00' : '#6c757d',
          lineHeight: 1,
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        Data em análise
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        <TextField
          label="Início"
          type="date"
          size="small"
          value={start}
          onChange={(e) => handleStartChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: dateInputValue(new Date()) }}
        />
        <TextField
          label="Término"
          type="date"
          size="small"
          value={end}
          onChange={(e) => handleEndChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: dateInputValue(new Date()) }}
        />
      </Box>
      {error ? (
        <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
          {error}
        </Typography>
      ) : null}
    </Box>
  );
}
